import { inject } from "@angular/core";
import { CanDeactivateFn } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { HasUnsavedFormChanges } from "../shared/interfaces/has-unsaved-form-changes";
import { confirmLeaveUnsavedChanges } from "../shared/utils/confirmation-dialog.utils";

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedFormChanges> = (component) => {
	if (!component?.hasUnsavedFormChanges?.()) {
		return true;
	}

	const dialog = inject(MatDialog);
	return confirmLeaveUnsavedChanges(dialog);
};
